import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const growthRatesAC: CriterionType[] = [
  {
    id: 'GR-10',
    label: 'Revenue growth rate',
    shortLabel: 'RevGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.time,
    timeOptions: ['yoy', '1y', '3y', '5y', '10y', '1q'],
    withRange: true,
  },
  {
    id: 'GR-30',
    label: 'Dividend yield growth rate',
    shortLabel: 'DivYldGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.time,
    timeOptions: ['1y', '3y', '5y', '10y'],
    withRange: true,
  },
  {
    id: 'GR-40',
    label: 'Total assets growth rate',
    shortLabel: 'AssetsGr',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'GR-50',
    label: 'Book value growth rate',
    shortLabel: 'BVGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'GR-60',
    label: 'Capital spending growth rate',
    shortLabel: 'CapExGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'GR-70',
    label: 'Cash flow growth rate',
    shortLabel: 'CFGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'GR-20',
    label: 'EPS growth rate',
    shortLabel: 'EPSGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.time,
    timeOptions: ['1y', '3y', '5y', '10y', '1q'],
    withRange: true,
  },
  {
    id: 'GR-90',
    label: 'Gross margin growth rate',
    shortLabel: 'GrossMgGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'GR-100',
    label: 'Net loans %change',
    shortLabel: 'NetLoans%Chg',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'GR-110',
    label: 'Net income growth rate',
    shortLabel: 'NIGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'GR-120',
    label: 'Net profit margin growth rate',
    shortLabel: 'NPMGr',
    unit: '%',
    group: AC_GROUPS.growthRates,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default growthRatesAC;
